(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vc-interactions"] && !Shopify.designMode) return;
  try {
    const VelnestiCurrency = (() => {
  function renderElement(el, force = false) {
    if (!el) return;
    const cents = Number(el.dataset.vcBaseCents);
    if (!Number.isFinite(cents)) return;
    const currency = el.dataset.currency || 'USD';
    const amount = (cents / 100).toFixed(2);
    if (!force && el.classList.contains('money') && el.getAttribute('ws-price') === amount && el.getAttribute('ws-currency') === currency) return;
    el.classList.add('money');
    el.setAttribute('ws-price', amount);
    el.setAttribute('ws-currency', currency);
    el.removeAttribute('data-vc-rendered-currency');
    el.classList.remove('done');
    el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency, currencyDisplay: 'code'
    }).format(cents / 100);
  }
  function renderAll(scope = document) {
    scope.querySelectorAll('[data-vc-base-cents]').forEach(el => renderElement(el, true));
  }
  function init() {
    renderAll();
    return Promise.resolve({ready: true});
  }
  return {init, renderAll, renderElement, get state() { return {ready: true}; }};
})();
window.VelnestiCurrency = VelnestiCurrency;


function updateVelnestiCartCount(count){
 document.querySelectorAll('.header__icon--cart').forEach(cartLink=>{
  const vcCount=cartLink.querySelector('.vc-cart-count');
  if(vcCount){vcCount.textContent=String(count);vcCount.hidden=count<1;}
  const bubble=cartLink.querySelector('.cart-count-bubble');
  if(bubble){
   bubble.hidden=count<1;
   const visibleCount=bubble.querySelector('span[aria-hidden="true"]');
   if(visibleCount)visibleCount.textContent=String(count);
  }
 });
}

function initVelnestiCartDrawer(){
 const drawer=document.querySelector('[data-vc-cart-drawer]');
 const overlay=document.querySelector('[data-vc-cart-overlay]');
 if(!drawer||!overlay||drawer.dataset.bound)return;
 drawer.dataset.bound='1';
 const lines=drawer.querySelector('[data-vc-cart-lines]');
 const empty=drawer.querySelector('[data-vc-cart-empty]');
 const footer=drawer.querySelector('[data-vc-cart-footer]');
 const count=drawer.querySelector('[data-vc-drawer-count]');
 const itemWord=drawer.querySelector('[data-vc-drawer-item-word]');
 const subtotal=drawer.querySelector('[data-vc-cart-subtotal]');
 const status=drawer.querySelector('[data-vc-cart-status]');
 const timer=drawer.querySelector('[data-vc-cart-timer]');
 let previousFocus=null;
 let timerId=null;

 const escapeHtml=value=>String(value??'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));
 const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:drawer.dataset.currency||'USD'}).format(Number(cents||0)/100);
 const showError=message=>{status.textContent=message||drawer.dataset.errorText;status.hidden=false;};
 const hideError=()=>{status.hidden=true;status.textContent='';};

 function startTimer(reset){
  let expires=0;
  try{expires=Number(sessionStorage.getItem('velnesti_cart_timer')||0);}catch(_){}
  if(reset||expires<=Date.now()){
   expires=Date.now()+300000;
   try{sessionStorage.setItem('velnesti_cart_timer',String(expires));}catch(_){}
  }
  if(timerId)window.clearInterval(timerId);
  const tick=()=>{
   const remaining=Math.max(0,expires-Date.now());
   const minutes=Math.floor(remaining/60000);
   const seconds=Math.floor((remaining%60000)/1000);
   timer.textContent=String(minutes).padStart(2,'0')+':'+String(seconds).padStart(2,'0');
   if(remaining===0&&timerId){window.clearInterval(timerId);timerId=null;}
  };
  tick();
  timerId=window.setInterval(tick,1000);
 }

 function openDrawer(resetTimer){
  previousFocus=document.activeElement;
  drawer.hidden=false;
  overlay.hidden=false;
  startTimer(Boolean(resetTimer));
  window.requestAnimationFrame(()=>{
   drawer.classList.add('is-open');
   overlay.classList.add('is-open');
   document.documentElement.classList.add('vc-cart-open');
   drawer.querySelector('[data-vc-cart-close]')?.focus();
  });
 }

 function closeDrawer(){
  drawer.classList.remove('is-open');
  overlay.classList.remove('is-open');
  document.documentElement.classList.remove('vc-cart-open');
  window.setTimeout(()=>{drawer.hidden=true;overlay.hidden=true;},250);
  if(previousFocus&&typeof previousFocus.focus==='function')previousFocus.focus();
 }

 function lineMarkup(item,index){
  const image=item.featured_image&&item.featured_image.url?item.featured_image.url:item.image;
  const variant=item.variant_title&&item.variant_title!=='Default Title'?'<p>'+escapeHtml(item.variant_title)+'</p>':'';
  const imageMarkup=image?'<img class="vc-cart-drawer__image" src="'+escapeHtml(image)+'" alt="'+escapeHtml(item.product_title||item.title)+'" width="100" height="112">':'<div class="vc-cart-drawer__image" aria-hidden="true"></div>';
  return '<article class="vc-cart-drawer__line">'+imageMarkup+'<div class="vc-cart-drawer__details"><h3>'+escapeHtml(item.product_title||item.title)+'</h3>'+variant+'<div class="vc-cart-drawer__row"><div class="vc-cart-drawer__quantity" aria-label="'+escapeHtml(drawer.dataset.quantityText)+'"><button type="button" data-vc-cart-change data-line="'+index+'" data-quantity="'+Math.max(0,item.quantity-1)+'" aria-label="'+escapeHtml(drawer.dataset.decreaseText)+'">−</button><span>'+item.quantity+'</span><button type="button" data-vc-cart-change data-line="'+index+'" data-quantity="'+(item.quantity+1)+'" aria-label="'+escapeHtml(drawer.dataset.increaseText)+'">+</button></div><strong data-vc-base-cents="'+item.final_line_price+'">'+money(item.final_line_price)+'</strong></div><button class="vc-cart-drawer__remove" type="button" data-vc-cart-change data-line="'+index+'" data-quantity="0">'+escapeHtml(drawer.dataset.removeText)+'</button></div></article>';
 }

 function renderCart(cart){
  const isEmpty=cart.item_count===0;
  count.textContent=String(cart.item_count);
  itemWord.textContent=cart.item_count===1?drawer.dataset.itemText:drawer.dataset.itemsText;
  if(cart.currency)drawer.dataset.currency=cart.currency;
  updateVelnestiCartCount(cart.item_count);
  empty.hidden=!isEmpty;
  lines.hidden=isEmpty;
  footer.hidden=isEmpty;
  lines.innerHTML=cart.items.map((item,index)=>lineMarkup(item,index+1)).join('');
  subtotal.dataset.vcBaseCents=String(cart.total_price);
  subtotal.textContent=money(cart.total_price);
  if(window.VelnestiCurrency&&window.VelnestiCurrency.state.ready)window.VelnestiCurrency.renderAll(drawer);
 }

 async function fetchCart(){
  const response=await fetch(drawer.dataset.cartUrl+'.js',{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'});
  if(!response.ok)throw new Error(drawer.dataset.errorText);
  return response.json();
 }

 async function changeLine(line,quantity){
  drawer.classList.add('is-loading');
  hideError();
  try{
   const response=await fetch(drawer.dataset.changeUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({line,quantity})});
   if(!response.ok){const failure=await response.json();throw new Error(failure.description||drawer.dataset.errorText);}
   renderCart(await response.json());
  }catch(error){
   showError(error.message);
  }finally{
   drawer.classList.remove('is-loading');
  }
 }

 document.querySelectorAll('.header__icon--cart').forEach(link=>link.addEventListener('click',async event=>{
  if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  event.preventDefault();
  hideError();
  try{renderCart(await fetchCart());}catch(error){showError(error.message);}
  openDrawer(false);
 }));
 drawer.addEventListener('click',event=>{
  const close=event.target.closest('[data-vc-cart-close]');
  if(close){closeDrawer();return;}
  const change=event.target.closest('[data-vc-cart-change]');
  if(change)changeLine(Number(change.dataset.line),Number(change.dataset.quantity));
 });
 overlay.addEventListener('click',closeDrawer);
 document.addEventListener('keydown',event=>{
  if(drawer.hidden)return;
  if(event.key==='Escape'){closeDrawer();return;}
  if(event.key!=='Tab')return;
  const focusable=Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'));
  if(!focusable.length)return;
  const first=focusable[0];
  const last=focusable[focusable.length-1];
  if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
  if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
 });
 window.VelnestiCartDrawer={open:openDrawer,render:renderCart,fetch:fetchCart};
}

function initVelnestiClone(){
 document.querySelectorAll('.vc-gallery').forEach(g=>{if(g.dataset.ready)return;g.dataset.ready='1';const images=g.querySelectorAll('.vc-gallery-stage img');g.querySelectorAll('.vc-thumbs button').forEach((b,i)=>b.addEventListener('click',()=>{images.forEach((img,n)=>img.hidden=n!==i);g.querySelectorAll('.vc-thumbs button').forEach((btn,n)=>btn.setAttribute('aria-pressed',String(n===i)));}));});
 document.querySelectorAll('.splide').forEach(s=>{if(s.dataset.ready)return;s.dataset.ready='1';const list=s.querySelector('.splide__list');if(!list)return;const controls=document.createElement('div');controls.className='vc-carousel-controls';[-1,1].forEach(direction=>{const b=document.createElement('button');b.type='button';b.textContent=direction<0?'←':'→';b.setAttribute('aria-label',direction<0?'Previous review':'Next review');b.addEventListener('click',()=>list.scrollBy({left:direction*list.clientWidth,behavior:'smooth'}));controls.append(b);});s.append(controls);});
 document.querySelectorAll('.vc-purchase').forEach(f=>{
  if(f.dataset.bound)return;
  f.dataset.bound='1';
  const message=f.querySelector('.vc-buy-message');
  const total=f.querySelector('[data-selected-total]');
  const addonInputs=()=>{const sel=f.querySelector('input[name=id]:checked:not(:disabled)');const pack=sel&&sel.closest('.vc-pack');return pack?Array.from(pack.querySelectorAll('.vc-addon-toggle')):[];};
  const updateTotal=()=>{
   const selected=f.querySelector('input[name=id]:checked:not(:disabled)');
   if(!selected||!total)return;
   let cents=Number(selected.dataset.cents)||0;
   addonInputs().forEach(addon=>{ if(addon.checked) cents+=Number(addon.dataset.cents)||0; });
   total.dataset.vcBaseCents=String(cents);
   if(window.VelnestiCurrency&&window.VelnestiCurrency.state.ready){
    window.VelnestiCurrency.renderElement(total);
   }else{
    total.textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:total.dataset.currency||'USD',currencyDisplay:'code'}).format(cents/100);
   }
  };
  f.addEventListener('change',updateTotal);
  updateTotal();
  f.addEventListener('submit',async event=>{
   event.preventDefault();
   const selected=f.querySelector('input[name=id]:checked:not(:disabled)');
   if(f.dataset.ready!=='true'||!selected){
    message.hidden=false;
    message.textContent=message.dataset.preview;
    return;
   }
   const buttons=f.querySelectorAll('button[type=submit]');
   const isCheckout=event.submitter&&event.submitter.name==='checkout';
   buttons.forEach(button=>button.disabled=true);
   message.hidden=true;
   try{
    const items=[{id:Number(selected.value),quantity:1}];
    addonInputs().forEach(addon=>{
     if(!addon.checked)return;
     const addonId=Number(addon.dataset.addonVariantId);
     if(addonId)items.push({id:addonId,quantity:1});
    });
    const response=await fetch(f.action+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
    if(!response.ok){const failure=await response.json();throw new Error(failure.description||message.dataset.error);}
    if(isCheckout){window.location.assign(f.dataset.checkoutUrl);return;}
    const cart=window.VelnestiCartDrawer?await window.VelnestiCartDrawer.fetch():null;
    if(cart&&window.VelnestiCartDrawer){
     window.VelnestiCartDrawer.render(cart);
     window.VelnestiCartDrawer.open(true);
    }else if(cart){
     updateVelnestiCartCount(cart.item_count);
    }else{
     window.location.assign(f.dataset.cartUrl);
    }
   }catch(error){
    message.hidden=false;
    message.textContent=error.message||message.dataset.error;
   }finally{
    buttons.forEach(button=>button.disabled=false);
   }
  });
 });
}
function initializeVelnesti(){
 initVelnestiCartDrawer();
 initVelnestiClone();
 VelnestiCurrency.init();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeVelnesti);else initializeVelnesti();
document.addEventListener('shopify:section:load',event=>{initVelnestiCartDrawer();initVelnestiClone();VelnestiCurrency.init().then(()=>VelnestiCurrency.renderAll(event.target||document));});
  } catch(e) { console.error(e); }
})();

})();
